import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/domestic-calls'),
      roles: ['administrator'],
      component: SettingsContent,
      props: {
        headerTitle: 'GENERAL_SETTINGS.DOMESTIC_CALLS.TITLE',
        icon: 'call-start',
        showNewButton: false,
      },
      children: [
        {
          path: '',
          name: 'domestic_calls',
          component: Index,
          roles: ['administrator'],
        },
      ],
    },
  ],
};